import React from 'react'

import { AnalyticsCardWrapper } from '../../components/AnalyticsCardWrapper/AnalyticsCardWrapper'
import {
  useContributionsPerTypeReportCard,
  useMembershipsActiveMembersReportCard,
  useMembershipsCancelledMembersReportCard,
  useMembershipsFreeAccountsReportCard,
  useMembershipsFreeTrialsReportCard,
  useMembershipsNewMembersReportCard,
  useMembershipsTierActivityReportCard,
  useMembershipsTopTiersByMembersReportCard,
  useTotalProfitReportCard,
} from '../../hooks/reportCards'

export const MembershipsAnalytics = () => {
  const membershipsProfitReportCard = useTotalProfitReportCard({
    type: 'memberships',
  })
  const membershipsTransactionsReportCard = useContributionsPerTypeReportCard({
    type: 'memberships',
  })
  const membershipsActiveMembersReportCard = useMembershipsActiveMembersReportCard()
  const membershipsNewMembersReportCard = useMembershipsNewMembersReportCard()
  const membershipsCancelledMembersReportCard = useMembershipsCancelledMembersReportCard()
  const membershipsFreeAccountsReportCard = useMembershipsFreeAccountsReportCard()
  const membershipsTierActivityReportCard = useMembershipsTierActivityReportCard()
  const membershipsTopTiersByMembersReportCard = useMembershipsTopTiersByMembersReportCard()
  const membershipsFreeTrialsReportCard = useMembershipsFreeTrialsReportCard()

  return (
    <>
      <AnalyticsCardWrapper {...membershipsProfitReportCard} />
      <AnalyticsCardWrapper {...membershipsActiveMembersReportCard} />
      <AnalyticsCardWrapper {...membershipsNewMembersReportCard} />
      <AnalyticsCardWrapper {...membershipsCancelledMembersReportCard} />
      <AnalyticsCardWrapper {...membershipsFreeAccountsReportCard} />
      <AnalyticsCardWrapper {...membershipsTransactionsReportCard} />
      <AnalyticsCardWrapper {...membershipsTopTiersByMembersReportCard} />
      <AnalyticsCardWrapper {...membershipsTierActivityReportCard} />
      <AnalyticsCardWrapper {...membershipsFreeTrialsReportCard} />
    </>
  )
}
